import React from 'react';
import { useLocation, Link } from 'react-router-dom';

interface NavigationItemProps {
  icon: React.ReactNode;
  label: string;
  path: string;
  description: string;
  isExpanded: boolean;
}

/**
 * ナビゲーション項目コンポーネント
 * 個々のナビゲーションリンクの表示を管理する
 */
const NavigationItem: React.FC<NavigationItemProps> = ({
  icon,
  label,
  path,
  description,
  isExpanded,
}) => {
  //#region ロケーション管理
  const location = useLocation();
  const isActive = location.pathname === path;
  //#endregion

  //#region レンダリング
  return (
    <Link
      to={path}
      className={`
        flex items-center px-4 py-3 my-1 mx-2 rounded-lg
        transition-all duration-200
        ${isActive ? 'bg-blue-600' : 'hover:bg-gray-800'}
        relative group
      `}
    >
      {/* アイコン */}
      <div className="flex-shrink-0">{icon}</div>

      {/* ラベルとディスクリプション */}
      {isExpanded && (
        <div className="ml-3 overflow-hidden">
          <div className="font-medium">{label}</div>
          <div className="text-sm text-gray-400 truncate">{description}</div>
        </div>
      )}

      {/* ツールチップ（閉じている時のみ表示） */}
      {!isExpanded && (
        <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 rounded-md 
                      invisible group-hover:visible whitespace-nowrap z-50">
          <div className="font-medium">{label}</div>
          <div className="text-sm text-gray-400">{description}</div>
        </div>
      )}
    </Link>
  );
};
export default NavigationItem;